import { render, staticRenderFns } from "./TebligatAlicisiPicker.vue?vue&type=template&id=3039d04e"
import script from "./TebligatAlicisiPicker.vue?vue&type=script&lang=ts"
export * from "./TebligatAlicisiPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports